import { render } from "./CopyrightFooter.vue?vue&type=template&id=0dfe2688&scoped=true"
const script = {}

import "./CopyrightFooter.vue?vue&type=style&index=0&id=0dfe2688&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dfe2688"]])

export default __exports__